import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { PaymentMethod } from "@/types/payment";
import { usePaymentValidation } from "./usePaymentValidation";

export const usePaymentQueries = (contactId: string) => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const { toast } = useToast();
  const { validatePaymentType } = usePaymentValidation();

  const fetchPaymentMethods = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('payment_methods')
        .select('*')
        .eq('user_id', contactId)
        .order('created_at', { ascending: false });

      if (error) throw error;

      const validatedData = (data || []).map(item => ({
        ...item,
        payment_type: validatePaymentType(item.payment_type)
      })) as PaymentMethod[];

      setPaymentMethods(validatedData);
    } catch (error) {
      console.error('Error fetching payment methods:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to fetch payment methods",
      });
    }
  }, [contactId, toast, validatePaymentType]);

  return {
    paymentMethods,
    fetchPaymentMethods
  };
};